
import _this from '@/main.js'
import dayjs from 'dayjs'
import { PROGRESS_LIST } from '../page/seventh/common/constant'
// 打开新页签跳转
const utilsObj = {
  windowOpen: (path, params) => {
    const { href } = _this.$router.resolve({
      path,
      query: params.query
    })
    window.open(href, '_blank')
  },
  //解决遮罩层滚动穿透问题，分别在遮罩层弹出后和关闭前调用
  modalHelper: ((bodyCls) => {
    let scrollTop;
    return {
      afterOpen: function () {
        scrollTop = document.scrollingElement.scrollTop;
        document.body.classList.add(bodyCls);
        document.body.style.top = -scrollTop + 'px';
      },
      beforeClose: function () {
        document.body.classList.remove(bodyCls);
        // scrollTop lost after set position:fixed, restore it back.
        document.scrollingElement.scrollTop = scrollTop;
      }
    };
  })('dialog-open'),
  share: (weixinAPI_init, weixinAPI_change, wxData) => {
    var imgUrlHandle = function (url) {
      if (url) {
        if (url.indexOf("http") == -1) {
          return window.location.protocol + '//' + window.location.host + url;
        }
      }
      return url;
    }
    weixinAPI_change(wxData)
    weixinAPI_init();
  },
  filterParams: (url) => {
    var newUrl = '';
    var urlPos = url.indexOf('?');
    if (urlPos > -1) {
      newUrl = url.substring(0, urlPos);
      var param = url.substring(urlPos + 1);
      var params = param.split('&');
      var param2 = [];
      for (var i in params) {
        if (params[i].indexOf('token=') < 0 && params[i].indexOf('fromapp=') < 0) {
          param2.push(params[i])
        }
      }
      if (param2.length > 0) {
        newUrl += '?' + param2.join('&');
      }
      return newUrl;
    } else {
      return url;
    }
  },
  formatNumToGreat: (num) => {
    num = + num;
    let numStr = "" + num;
    let oneBillion = 100000000;
    let tenThousand = 10000;
    if (num / oneBillion > 1) {
      let billion = num / oneBillion;
      billion = Math.floor(billion * 100) / 100;
      numStr = billion + "亿";
    } else if (num / tenThousand >= 1) {
      let wan = num / tenThousand;
      wan = Math.floor(wan * 100) / 100;
      numStr = wan + "w";
    }
    return numStr
  },
  groupArray: (array, subGroupLength) => { //切割数组
    let index = 0;
    let newArray = [];
    while (index < array.length) {
      newArray.push(array.slice(index, index += subGroupLength));
    }
    return newArray;
  },
  getQueryString: (name) => {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return (r[2]); return null;
  },
  checkVoteLogin:(api,token,callback,fromapp)=>{
    let isLoginFla = false
     api({token:encodeURIComponent(token),fromapp}).then((res)=>{
      if(res && res.success){
        isLoginFla = true
      } else {
        if(res.msg == 'login') {
          isLoginFla = false
        }
      }
      if(callback && typeof (callback) == 'function') callback(res,isLoginFla)
    })
  },
  imgload(src,callabck, options) {
    const { scale = 0.5 } = options || {}
    let self = this;
    let img = new Image();
    img.src = src;
    img.onload = () => {
      callabck((img.width * scale).toFixed(2))
      // this.$set(
      //   this.partnerList[i].ico[index],
      //   "width",
      //   (img.width * 0.5).toFixed(2)
      // );
    };
  },
  getIndex(arr, num) {
    let index = arr.findIndex(function (item) {
      return (item.itemId || item.id) == num;
    });
    return index;
  },

  /**
   * @desc 图片 URL 添加尺寸
   * @param {String} url 图片地址
   * @param {Object} [options] 可选，配置项
   * @prop {Number|String} [options.width=237] 可选，图片宽度
   * @prop {Number|String} [options.height=217] 可选，图片高度
   * @return {String} 返回添加尺寸信息后的图片 URL
   */
  addImageUrlSize(url, options) {
    if (!url) {
      return
    }

    const { width = 237, height = 217 } = options || {}
    const size = `size=${width}_${height}`

    return `${url}${url.includes('?') ? '&' : '?'}${size}`
  },
  toRouter(timeline) {
    const client = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    const timelineList = []
    const now = dayjs.unix(timeline).format('YYYY-MM-DD')
    Array.isArray(PROGRESS_LIST) && PROGRESS_LIST.forEach(item => {
      const { startTime, endTime } = item
      
      timelineList.push({
        ...item,
        active: endTime
          ? dayjs(now).isBetween(startTime, endTime, 'day', '[]')
          : dayjs(now).isSameOrAfter(startTime)
      })
    })
    let routerPath
    if(Array.isArray(timelineList)){
      timelineList.forEach(item => {
        if(item.active) routerPath = client ? item.routerPathH5 : item.routerPathPC
      })
    }else{
      routerPath = "outcomePc"
    }
    return routerPath
  }
}
export default utilsObj



// WEBPACK FOOTER //
// ./src/utils/utils.js